import React, { useState } from 'react';
import { ExpandingListItemHeader, ExpandIcon } from './styles';

export default function FreecodeCourseExpandingItem({ title, children, openDyDefault, toggled }) {
  const [isOpen, setIsOpen] = useState(openDyDefault);

  const updateIsOpen = () => {
    let newValue = !isOpen;
    setIsOpen(newValue);
    if (toggled) toggled(newValue);
  };

  return (
    <>
      <ExpandingListItemHeader onClick={updateIsOpen}>
        {title}
        {<ExpandIcon icon={isOpen ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} />}
      </ExpandingListItemHeader>
      {isOpen && children}
    </>
  );
}
